<template>
  <section>
    <NetworkLogsBottomSheet
      :name="name"
      :network-logs="networkLogs.logs"
      @onClearLogs="networkLogs.clear"
      @onLogSelect="logSelect"
    />
    <NetworkLogDetailsBottomSheet :name="networkDetailsBottomSheetName" />
  </section>
</template>

<script setup lang="ts">
  import { controllerModel } from 'shared';

  import NetworkLogsBottomSheet from './NetworkLogsBottomSheet.vue';
  import NetworkLogDetailsBottomSheet from './NetworkLogDetailsBottomSheet.vue';
  import { networkLog } from '../../../entities/network-log';

  defineProps<{ name: string }>();

  const networkDetailsBottomSheetName = 'network-details-bottom-sheet';
  const bottomSheet = controllerModel.useBottomSheet();

  const networkLogs = networkLog.model.useNetworkLogs();

  const logSelect = (id: string) => {
    bottomSheet.show(networkDetailsBottomSheetName, {
      log: networkLogs.logs[id],
    });
  };
</script>
